
const headers = [
  {
    label: 'เลขร้องทุกข์',
    field: 'complaintCode',
  },
  {
    label: 'วันที่ยื่นเรื่อง / ช่องทาง',
    field: 'complaintDate'
  },
  {
    label: 'ผู้ประกอบการ / ชื่อผู้ร้องทุกข์ หรือ ผู้มอบอำนาจ',
    field: 'companyName',
  },
]

export default headers